import type { Database as Schema } from './database';

// Export product type from the database schema
export type Product = Schema['public']['Tables']['products']['Row'];

export type TireSize = {
  width: number;
  profile: number;
  rim_size: number; // Database name (snake_case)
  rimSize?: number; // Frontend name (camelCase)
};

export type VehicleType = 'car' | 'suv' | 'truck' | 'sports';

export enum ServiceType {
  FITTING = 'Professional Fitting',
  PICKUP = 'Self-Pickup'
}

export type Review = {
  id: string;
  user_id: string;
  user_name: string;
  rating: number;
  comment: string;
  date: string;
};

export type Tire = {
  id: string;
  brand: string;
  model: string;
  size: {
    width: number;
    profile: number;
    rimSize: number; // Frontend uses camelCase
    rim_size?: number; // Database uses snake_case
  };  vehicle_types: VehicleType[];
  vehicleTypes?: VehicleType[]; // Frontend camelCase alias
  price: number;
  sale_price?: number;
  salePrice?: number; // Frontend camelCase alias
  image: string;
  description: string;
  information?: string;
  features: string[];
  specifications: Record<string, string>;
  stock: Record<string, number>;
  reviews: Review[];
  avg_rating: number;
  avgRating?: number; // Frontend camelCase alias
  created_at?: string;
  updated_at?: string;
  status?: string;
};

export type Location = {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  postal_code?: string; // Keep for backward compatibility
  phone: string;
  email: string;
  businessHours: Record<string, string>;
  business_hours?: Record<string, string>; // Keep for backward compatibility
  coordinates: {
    lat: number;
    lng: number;
  };
};

export type CartItem = {
  tire: Tire;
  quantity: number;
};

export type CartState = {
  items: CartItem[];
  service_type: ServiceType;
  selected_location_id: string | null;
  total: number;
};

export type Order = {
  id: string;
  user_id: string;
  items: CartItem[];
  service_type: ServiceType;
  location_id: string | null;
  total: number;
  status: 'Pending' | 'Processing' | 'Completed' | 'Cancelled';
  payment_method: string;
  payment_status: 'Pending' | 'Paid' | 'Failed';
  created_at: string;
  appointment_date?: string;
};

export type User = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
  };
  orders: string[];
  isAdmin: boolean;
  emailConfirmationPending?: boolean;
};

export interface CustomerOrder {
  id: string;
  date: string;
  status: string;
  total: number;
}

export type Customer = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  joinDate: string;
  totalOrders: number;
  totalSpent: number;
  lastOrderDate: string;
  preferredLocation?: string;
  notes?: string;
  orders?: CustomerOrder[];
  paymentMethods?: string[];
};